<script>
import AdminLayout from '@layouts/admin-main'
import PgMerchantList from '@components/admin/pg-merchant-list'

export default {
  page: {
    title: 'Admin::PgMerchantList',
    meta: [{ name: 'description', content: 'Admin::PgMerchantList' }],
  },
  components: { AdminLayout, PgMerchantList },
}
</script>

<template>
  <AdminLayout>
    <PgMerchantList></PgMerchantList>
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@design';
</style>
